import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgaReadMoreComponent } from './nga-read-more.component';

@NgModule({
  declarations: [NgaReadMoreComponent],
  imports: [
    BrowserModule
  ],
  exports: [NgaReadMoreComponent]
})
export class NgaReadMoreModule { }
